import ViewController from "core/views/view.controller";

export default class BookingDetailsCtrl extends ViewController {
    static $inject = ['$scope', 'textModal', 'Bookings', 'Vehicles', 'bookingProcessorSelectionModal', 'bookingColorSelectionModal', 'bookingStateSelectionModal'];

    constructor() {
        super(...arguments);

        this.vehicleChecks = [];
        this.lastVehicleChecks = [];

        // Bindings
        this.booking = null;
        this.showCustomer = true;
        this.showVehicle = true;
        this.showVehicleChecks = true;
        this.showWheelStorage = true;
        this.saveBookingOnUpdate = true;
        this.onBookingUpdated = null;
    }

    $onChanges(changes) {
        if (changes.showCustomer && this.showCustomer == null) {
            this.showCustomer = true;
        }

        if (changes.showVehicle && this.showVehicle == null) {
            this.showVehicle = true;
        }

        if (changes.showVehicleChecks && this.showVehicleChecks == null) {
            this.showVehicleChecks = true;
        }

        if (changes.showWheelStorage && this.showWheelStorage == null) {
            this.showWheelStorage = true;
        }

        if (changes.saveBookingOnUpdate && this.saveBookingOnUpdate == null) {
            this.saveBookingOnUpdate = true;
        }

        if (changes.booking && changes.booking.currentValue) {
            this.vehicleChecks = [];
            this.lastVehicleChecks = [];

            if (this.showVehicleChecks) {
                this.loadVehicleChecks(this.booking);
            }
        }

        this.$scope.$broadcast('$$rebind::' + 'refreshBookingDetails');
    }

    loadVehicleChecks(booking) {
        if (booking.vehicle == null) {
            return;
        }

        this.Vehicles.allVehicleChecks(booking.vehicle.id).then((vehicleChecks) => {
            this.vehicleChecks = vehicleChecks;

            if (vehicleChecks.length > 0) {
                this.lastVehicleChecks = vehicleChecks;
            }
        });
    }

    editBookingState() {
        this.bookingStateSelectionModal.show({
            selectedState: this.booking.state

        }).then((state) => {
            if (this.booking.state != state) {
                this.booking.state = state;
                this.saveBooking();
            }
        });
    }

    editBookingDescription() {
        let self = this;

        this.textModal.show({
            title: "BOOKING_DESCRIPTION",
            text: self.booking.description,

            onSave: (text) => {
                self.booking.description = text;
                this.saveBooking();
            }
        })
    }

    editBookingColor() {
        this.bookingColorSelectionModal.show({
            color: this.booking.backgroundColor,
            colorCols: 4

        }).then((color) => {
            if (this.booking.backgroundColor !== color) {
                this.booking.backgroundColor = color;
                this.saveBooking();
            }
        });
    }

    editBookingProcessor() {
        this.bookingProcessorSelectionModal.show({
            selectedProcessor: this.booking.processor

        }).then((processor) => {
            let processorName = processor ? processor.name : null;

            if (this.booking.processor != processorName) {
                this.booking.processor = processorName;
                this.saveBooking();
            }
        });
    }

    saveBooking() {
        if (this.saveBookingOnUpdate) {
            this.booking.save().then(()=> {
                this.onBookingUpdated({booking: this.booking});
                this.$scope.$broadcast('$$rebind::' + 'refreshBookingDetails');
            })
        } else {
            this.onBookingUpdated({booking: this.booking});
        }
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/components/booking-details/booking-details.controller.js